/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

export const getCookieByName = (name: string): string | undefined =>
  document.cookie
    .split('; ')
    .find((row) => row.startsWith(name))
    ?.split('=')[1];

export const deleteCookie = (name: string): void => {
  if (getCookieByName(name)) {
    document.cookie = name + '=; Max-Age=0';
    return;
  }
  console.log(`No cookie with name ${name} found`);
};

export const SPS_INFO_ACCESS_TOKEN = 'SPS-INFO_ACCESS_TOKEN';
